// extracted by mini-css-extract-plugin
export var logo = "_58-2";
export var logoWrapper = "_58-1";
export var strip = "_58-0";